export default __webpack_public_path__ + "static/media/Dual Ring-1s-200px.83d92948.svg";